import React from 'react'
import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'

import { Flex, getPaletteColor } from 'pcln-design-system'

const RotateInfinite = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const StyledSpinner = styled.div`
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  animation: ${RotateInfinite} ${(props) => props.cycleTime} linear infinite;
  border: ${(props) => props.borderWidth}px solid ${getPaletteColor('base')};
  border-right-color: transparent;
  border-radius: 50%;
  display: inline-block;
  height: ${(props) => `${props.size}px`};
  width: ${(props) => `${props.size}px`};
  align-self: center;
`

const IconBox = styled(Flex)`
  width: ${(props) => props.size - props.borderWidth * 2}px;
  height: ${(props) => props.size - props.borderWidth * 2}px;
  border-radius: ${(props) => (props.size - props.borderWidth * 2) / 2}px;
`

const StyledLogo = styled.div`
  top: ${(props) => props.borderWidth}px;
  left: ${(props) => props.borderWidth}px;
  position: absolute;
`

const StyledWrapper = styled.div`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  position: relative;
`
/**
 * Accepts an iconNode and renders a spinner around the icon
 */
const SpinningIcon = ({ iconNode, size, color, borderWidth, cycleTime, iconZoom }) => {
  const icon = React.cloneElement(iconNode, {
    color,
    size: Math.floor((size / 7) * 3 * iconZoom),
  })

  return (
    <StyledWrapper size={size}>
      <StyledSpinner color={color} size={size} borderWidth={borderWidth} cycleTime={cycleTime} />
      <StyledLogo size={size} borderWidth={borderWidth}>
        <IconBox
          color='background.lightest'
          alignItems='center'
          justifyContent='center'
          size={size}
          borderWidth={borderWidth}
        >
          {icon}
        </IconBox>
      </StyledLogo>
    </StyledWrapper>
  )
}

SpinningIcon.propTypes = {
  /**
   * the icon to render - typically a component imported from 'pcln-icons'
   */
  iconNode: PropTypes.node.isRequired,
  color: PropTypes.string,
  size: PropTypes.number,
  cycleTime: PropTypes.string,
  borderWidth: PropTypes.number,
  iconZoom: PropTypes.number,
}

SpinningIcon.defaultProps = {
  color: 'primary',
  size: 78,
  cycleTime: '0.8s',
  borderWidth: 2,
  iconZoom: 1,
}

export default SpinningIcon
